import { useState } from "react";
import { FacebookLogo, XLogo, LinkSimple, Check, ShareNetwork, InstagramLogo } from "@phosphor-icons/react";

const ORIGIN = "https://seprotection.com";

export default function ShareBar({ slug, title }) {
  const [copied, setCopied] = useState(false);
  const shareUrl = `${ORIGIN}/api/s/${slug}`;
  const text = encodeURIComponent(title);

  const copy = async () => {
    try { await navigator.clipboard.writeText(shareUrl); } catch { /* clipboard blocked */ }
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };

  const native = async () => {
    if (navigator.share) {
      try { await navigator.share({ title, url: shareUrl }); } catch { /* cancelled */ }
    } else {
      copy();
    }
  };

  const btn = "inline-flex items-center gap-2 border border-white/15 px-3 py-2 font-mono text-[11px] tracking-[0.15em] uppercase text-neutral-300 hover:border-[#FFD300] hover:text-[#FFD300] transition-colors";

  return (
    <div className="flex flex-wrap items-center gap-2" data-testid="share-bar">
      <span className="overline mr-1">Share</span>
      <a href={`https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(shareUrl)}`} target="_blank" rel="noopener noreferrer" className={btn} data-testid="share-facebook" aria-label="Share on Facebook">
        <FacebookLogo size={16} weight="fill" /> Facebook
      </a>
      <a href={`https://twitter.com/intent/tweet?url=${encodeURIComponent(shareUrl)}&text=${text}`} target="_blank" rel="noopener noreferrer" className={btn} data-testid="share-x" aria-label="Share on X">
        <XLogo size={16} weight="fill" /> X
      </a>
      <button type="button" onClick={copy} className={btn} data-testid="share-instagram" aria-label="Copy link for Instagram" title="Instagram has no web share — link copied to paste in your story or bio">
        <InstagramLogo size={16} weight="fill" /> Instagram
      </button>
      <button type="button" onClick={copy} className={btn} data-testid="share-copy">
        {copied ? <><Check size={16} weight="bold" className="text-[#FFD300]" /> Copied</> : <><LinkSimple size={16} /> Copy link</>}
      </button>
      <button type="button" onClick={native} className={`${btn} md:hidden`} data-testid="share-native" aria-label="Share">
        <ShareNetwork size={16} />
      </button>
    </div>
  );
}
